/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  dialogPaper: {
    maxWidth: '760px',
    alignItems: 'center',
    height: '70vh',
    overflowY: 'unset',
    maxHeight: 640,
    width: '80vw',
    justifyContent: 'space-around',
    padding: '0 32px',
    [theme.breakpoints.down('sm')]: {
      margin: 'auto 24px',
      justifyContent: 'flex-start',
      padding: '16px 15px 28px',
      maxHeight: '361px',
    },
  },

  eirDialogContainer: {
    textAlign: 'center',
  },

  eirDialogTitle: {
    padding: '0 0 14px',
    width: '100%',
    borderBottom: '1px solid #e0e0e0',
    '& h2': {
      fontFamily: `eir-medium`,
      color: theme.palette.primary.offerMain,
      fontSize: 24,
      lineHeight: 2,
    },
    [theme.breakpoints.down('sm')]: {
      borderBottom: 'none',
      padding: '0 0 24px',
      '& h2': {
        fontSize: 20,
      },
    },
  },

  eirDialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'unset',
    flex: 'unset',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  notification: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
    fontSize: '16px',
    textAlign: 'center',
    fontFamily: `gt-walsheim-regular`,
    lineHeight: '25px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '25px',
      marginBottom: '10px',
      '& p': {
        width: '80%',
        margin: '0 auto',
      },
    },
  },
  eirDialogAction: {
    padding: 0,
  },
  eirDialog: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      marginBottom: 10,
    },
  },

  button: { outline: 'none' },

  eirButton: {
    padding: '8px 32px 0',

    color: theme.palette.primary.eirButton,
    '&:hover': {
      background: theme.palette.primary.hoverCTA,
      color: theme.palette.primary.contrastText,
    },
  },

  purpleBtn: {
    padding: '8px 32px',
    background: theme.palette.primary.eirButton,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      background: theme.palette.primary.hoverCTA,
      color: theme.palette.primary.contrastText,
    },
  },

  image: {
    marginBottom: '39px !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px !important',
    },
  },
});
export default styles;
